export const links = {
	galleryUrl: 'https://whitecrust-clients-storage.nyc3.digitaloceanspaces.com',
	// AUTH ENDPOINTS
	login: 'auth/login',
	loginVerify: 'auth/verifyLogin',
	forgotPassword: 'auth/forget',
	resetPassword: 'auth/reset',
	createAccount: 'auth/register',
	createToken: 'auth/generate_token',
	checkToken: 'auth/check',
	verifyToken: 'auth/verify',
	// UTILITIES ENDPOINTS
	listBanks: 'list_banks',
	validateBanks: 'validate_account',
	listBranches: 'list_branches',
	listStates: 'list_states',
	listProducts: 'list_products',
	// DASHBOARD ENDPOINTS
	dashboard: 'dashboard',
	profile: 'profile',
	markAllNotifications: 'mark_all_notifications',
	showNotifications: 'show_notification',
	logout: 'logout',
	// SEARCH CUSTOMER ENDPOINTS
	searchCustomer: 'search_customer',
	viewCustomer: 'view_customer',
	// LOANS ENDPOINTS
	loans: 'loans',
	verifyLoan: 'validate-loan',
	previewLoans: 'loans/preview',
	loanTopup: 'loan-topup',
	previewOffer: 'offers/preview',
	acceptOffer: 'offers/accept_offer',
	loanFileUpload: 'loan-file-upload',
	// VERIFICATION ENDPOINTS
	verifyBvn: 'verify_bvn',
	verifyNin: 'verify_nin',
	salaryLookup: 'salary',
};
